<template>
    <div>
         <!-- 头部 -->
       <top></top>
       <div class="main">
            <navMenu :active="active"></navMenu>
            <div class="content">
                <div class="header_main">
	             <div class="header_title">{{itemdata.name}}（适用于品牌方和工厂企业）</div>
	         </div>
	         <div class="content_main">
	             <div class="content_main_title">参选产品信息</div>
                   <!-- 产品基本模版表单 -->
	              <template v-if="templateTpye==8">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm" label-position="top">
	                       <!--同步产品信息-->
	                           <el-row>
                                 <el-col :span="8">
        	                        <el-form-item label="产品名称：" prop="goodsName">
                                        <el-input v-model="ruleForm.goodsName"  placeholder="请输入产品名称"></el-input>
                                    </el-form-item>
            	                    </el-col>
                                    <el-col :span="5">
        	                        <el-form-item label="年销售额：" prop="yearSale">
                                        <el-input type="text" v-model="ruleForm.yearSale"  placeholder="请输入年销售额"></el-input>
                                    </el-form-item>
        	                    </el-col>
	                           </el-row>
	                           <el-row>
                                 <el-col :span="8">
        	                         <el-form-item label="产品类别：" prop="nhne_ProductClass">
                                        <el-select  v-model="ruleForm.nhne_ProductClass" placeholder="请选择产品类别" popper-class="type-select" style="width:100%">
                                             <el-option
                                              v-for="(item,index) in productlist"
                                              :key="index"
                                              :label="item.class_name"
                                              :value="item.class_name">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
            	                    </el-col>
                                    <el-col :span="8">
        	                        <el-form-item label="产品标签（限选两项）：" prop="newfeatures">
                                       <el-select
                                            v-model="ruleForm.newfeatures"
                                            multiple
                                            collapse-tags
                                            style="width:100%"
                                            multiple-limit="2"
                                            placeholder="请选择产品特点(最多两项)">
                                            <el-option
                                              v-for="(item,index) in tablist.productAbbr_option"
                                              :key="index"
                                              :label="item.val"
                                              :value="item.val">
                                            </el-option>
                                          </el-select>
                                          </el-form-item>
        	                         </el-col>
	                           </el-row>
	                           <el-row>
                                 <el-col :span="8">
        	                         <el-form-item label="产品简介：" prop="introduction">
                                          <el-input type="textarea" v-model="ruleForm.introduction" rows="4" resize="none" placeholder="须包含与同类产品差异化特点或卖点"></el-input>
                                    </el-form-item>
            	                    </el-col>
            	                    <el-col :span="8">
            	                        <el-form-item label="产品卖点："  prop="advantages">
                                              <el-input type="textarea" v-model="ruleForm.advantages" rows="4" resize="none" placeholder="请输入产品卖点"></el-input>
                                        </el-form-item>
        	                        </el-col>
                                  
	                           </el-row>
                               <el-row>
                                 <el-col :span="8">
                                     <el-form-item label="工艺特点：" prop="characteristic">
                                          <el-input type="textarea" v-model="ruleForm.characteristic" rows="4" resize="none" placeholder="请输入工艺特点"></el-input>
                                    </el-form-item>
            	                    </el-col>
                                    
                               </el-row>
	                            <el-row>
	                                 <el-col :span="24">
        	                        <el-form-item label="产品配料表：" prop="burdenImg">
                                        <div class="awards-upload">
                                                <el-upload 
                                                    :before-upload="beforeUpload"
                                                    ref="upload"
                                                    action="/" 
                                                    list-type="picture-card"
                                                    name='imgFile'
                                                    :file-list="ruleForm.burdenImg"
                                                    accept=".pdf, .png , .jpg, .jepg"
                                                >
                                             <div slot="file" slot-scope="{ file }">
                                                <div>
                                                    <img
                                                    class="el-upload-list__item-thumbnail"
                                                    :src="isPDF(file.url) ? '../images/pdf_icon.jpg' : file.url"
                                                    :style="{maxWidth:isPDF(file.url) ? '75%' : '100%',maxHeight:isPDF(file.url) ? '75%' : '100%'}"
                                                    alt="" />
                                                    <span
                                                      v-if="file.status === 'success'"
                                                      class="el-upload-list__item-actions"
                                                    >
                                                      <span
                                                        class="el-upload-list__item-preview"
                                                        @click="handlePreview(file)"
                                                      >
                                                        <i class="el-icon-zoom-in"></i>
                                                      </span>
                                                      <span
                                                        class="el-upload-list__item-delete"
                                                        @click="handleRemove(file)"
                                                      >
                                                        <i class="el-icon-delete"></i>
                                                      </span>
                                                    </span>
                                                </div>
                                              </div>
                                                    <div class="upload-tip">
                                                        <i>
                                                            <img class="upload-img" mode="widthFix" src="../../assets/discussion/discussion_upload.jpg" >
                                                            <div class="tips">请上传PDF或图片</div>
                                                        </i>
                                                    </div>
                                                </el-upload>
                                                 <el-dialog :visible.sync="dialogVisible">
                                                   <img style="max-width:80%;max-height: 500px;margin: 0 auto;" :src="dialogImageUrl" alt="">
                                                </el-dialog>
                                            </div>
                                    </el-form-item>
        	                    </el-col>
	                           </el-row>
	                           <el-row>
                                 <el-col :span="24">
        	                          <el-form-item label="产品图片：" prop="imgs">
                                              <el-upload
                                                class="tp_update"
                                                action="/kindeditor/php/uploadApi.php?mode=3"
                                                name='imgFile'
                                                :on-success="handleAvatarPictureSuccess"
                                                list-type="picture-card"
                                                :show-file-list="false"
                                               
                                            >
                                                <img v-if="cpImgList[0]" :src="Imghttp + cpImgList[0]" class="avatar">
                                                <div class="upload-tip" v-else>
                                                    <i class="el-icon-plus">
                                                        <p class="el-icon-tip">请上传高清图片</p>
                                                    </i>
                                                </div>
                                            </el-upload>
                                    </el-form-item>
                                    </el-col>
	                           </el-row> 
                               <el-row>
                             <el-form-item class="save_btn">
                                 <a style="margin-right:10px" ><el-button >返 回</el-button></a>
                                 <el-button type="primary"  @click="submitForm('ruleForm',1)" :disabled="disableds">保存</el-button>
                                
                            </el-form-item>
                             
                        </el-row>
                    </el-form>
                  </template>
                 <!-- 货架好物报名模版表单 || 选品对接会报名模版表单 -->
                  <template v-if="templateTpye==1||templateTpye==2||templateTpye==3">
                    <el-form :model="shelfGoodsRuleForm" :rules="shelfGoodsRules" ref="shelfGoodsRuleForm" label-width="180px" class="demo-ruleForm" label-position="top">
                             <el-row>
                                 <el-col :span="8">
        	                        <el-form-item label="产品名称：" prop="goodsName">
                                        <el-input v-model="shelfGoodsRuleForm.goodsName"  placeholder="请输入产品名称"></el-input>
                                    </el-form-item>
            	                    </el-col>
                                    <el-col :span="8">
                                     <el-form-item label="上市时间：" prop="market_time_new">
                                         <el-date-picker
                                                 style="width: 100%;"
                                                 v-model="shelfGoodsRuleForm.market_time_new"
                                                 type="date"
                                                 :picker-options="pickeroptions0"
                                                 placeholder="选择上市时间">
                                         </el-date-picker>
                                     </el-form-item>
                                 </el-col>
                                    <!--<el-col :span="8">-->
                                        <!--<el-form-item label="产品类别：" prop="changeproductClass">-->
                                            <!--<el-cascader  @change="handleChange"  v-model="shelfGoodsRuleForm.changeproductClass" style="width: 100%;" :options="productClass" :show-all-levels="false"></el-cascader>-->
                                        <!--&lt;!&ndash; <el-select  v-model="shelfGoodsRuleForm.productClass" placeholder="请选择产品类别" popper-class="type-select" style="width:100%">-->
                                             <!--<el-option-->
                                              <!--v-for="(item,index) in productlist"-->
                                              <!--:key="index"-->
                                              <!--:label="item.class_name"-->
                                              <!--:value="item.class_name">-->
                                            <!--</el-option>-->
                                        <!--</el-select> &ndash;&gt;-->
                                    <!--</el-form-item>-->
        	                        <!--</el-col>-->
                                    
	                    </el-row>
                        <el-row>

                            <el-col :span="8">
                                <el-form-item label="产品年销售额(单位:万元)：" prop="yearSale">
                                    <el-input type="number" v-model="shelfGoodsRuleForm.yearSale"  placeholder="仅做渠道对接参考，不对外公布"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="产品零售价(单位:元)：" prop="retail_price">
                                    <el-input type="number" v-model="shelfGoodsRuleForm.retail_price"  placeholder="仅做渠道对接参考，不对外公布"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>

                            <el-col :span="8">
                                <el-form-item label="目前已有主要销售渠道：" prop="sales_channel">
                                    <el-input v-model="shelfGoodsRuleForm.sales_channel"  placeholder="仅做渠道对接参考，不对外公布"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="希望开拓销售渠道：" prop="expand_channels">
                                    <el-input v-model="shelfGoodsRuleForm.expand_channels"  placeholder="仅做渠道对接参考，不对外公布"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>

                            <el-col :span="8">
                                <el-form-item label="产品简介：" prop="introduction">
                                    <el-input type="textarea" v-model="shelfGoodsRuleForm.introduction" rows="4" resize="none" placeholder="须包含与同类产品差异化特点或卖点"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="产品图片：" prop="imgs" class="form-width">
                                    <div class="image" v-if="shelfGoodsRuleForm.imgs">
                                        <el-image :src="$imgOssUrl + shelfGoodsRuleForm.imgs"></el-image>
                                        <div class="upload-span">
                                        <span
                                                class="upload-icon"
                                                @click.stop="
                                            handlePictureCardPreview($imgOssUrl + shelfGoodsRuleForm.imgs)
                                        "
                                        ><i class="el-icon-zoom-in"></i
                                        ></span>
                                            <span
                                                    class="upload-icon"
                                                    @click.stop="handleRemove()"
                                                    style="margin-left: 20px"
                                            ><i class="el-icon-delete"></i
                                            ></span>
                                        </div>
                                    </div>
                                    <div v-if="!shelfGoodsRuleForm.imgs">
                                        <el-upload
                                                :action="$Url"
                                                list-type="picture-card"
                                                :headers="headers"
                                                :multiple="false"
                                                :on-progress="handleProgressCp"
                                                :on-success="handleLogoSuccess"
                                                :on-error="handleLogoError"
                                                :show-file-list="false"
                                        >
                                            <i class="el-icon-plus" v-if="!progressCpVisible"></i>
                                            <div v-if="progressCpVisible" style="padding-top: 30px">
                                                <el-progress
                                                        :percentage="progressCpPercent"
                                                        type="circle"
                                                        :width="80"
                                                ></el-progress>
                                            </div>
                                        </el-upload>
                                    </div>
                                    <div class="img-tips">
                                        上传图片接受JPG、PNG格式、图片大小不超过2M,分辨率不小于300dpl
                                    </div>
                                </el-form-item>
                            </el-col>

                        </el-row>
                        <!--<el-row>-->
                            <!--<el-col :span="12">-->
                                <!--<el-form-item label="" prop="up_suggestarr">-->
                                    <!--<span style="color: red;">* </span>货架选择 <span style="color: red;">(请选择最匹配的货架场景，仅限选一项，货架名额满后，主办方将根据货架情况调剂)</span>-->
                                    <!--<div v-for="(items,index) in dictData.up_suggest" :key="index">-->
                                        <!--<el-col  :span="24">{{ index }}</el-col>-->
                                        <!--<el-checkbox-group  v-model="shelfGoodsRuleForm.up_suggestarr" @change="handleselectionChange">-->
                                            <!--<el-checkbox v-for="(item,idx) in items" :key="idx" :label="item"></el-checkbox>-->
                                        <!--</el-checkbox-group>-->
                                    <!--</div>-->
                                    <!--<el-col :span="24"><el-checkbox v-model="shelfGoodsRuleForm.up_suggestarr"  @change="handleselectionChange" label="其他"></el-checkbox>:(以上都没有，请详细填写)</el-col>-->
                                    <!--<el-input v-model="hjxz"  v-if="shelfGoodsRuleForm.up_suggestarr.includes('其他')"  placeholder="以上都没有，请详细填写"></el-input>-->
                                <!--</el-form-item>-->
                            <!--</el-col>-->
                        <!--</el-row>-->
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="" prop="up_suggest1">
                                    <span style="color: red;">* </span>货架选择：<span style="color: red;">(请选择最匹配的货架场景，仅限选一项，货架名额满后，主办方将根据货架情况调剂)</span>

                                    <el-radio-group  v-model="shelfGoodsRuleForm.up_suggest1" >
                                        <el-radio v v-for="(item,index) in dictData.up_suggest" :key="index" :label="item">{{ item }}</el-radio>
                                    </el-radio-group>

                                    <el-col :span="24"><el-radio v-model="shelfGoodsRuleForm.up_suggest1"  label="其他"></el-radio>:(以上都没有，请详细填写)</el-col>
                                    <el-input v-model="hjxz"  v-if="shelfGoodsRuleForm.up_suggest1=='其他'"  placeholder="以上都没有，请详细填写"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <!--极智工场报名  表单-->
                        <template v-if="templateTpye=='3'">
                            <el-row>
                                 <el-col :span="16">
        	                        <el-form-item label="可生产剂型" prop="used_dosagearr">
                                        <el-checkbox-group v-model="shelfGoodsRuleForm.used_dosagearr">
                                            <el-checkbox v-for="(item,index) in dictData.used_dosage" :key="index" :label="item"></el-checkbox>
                                        </el-checkbox-group>
                                        <el-col :span="24"><el-checkbox  v-model="shelfGoodsRuleForm.used_dosagearr" label="其他"></el-checkbox>:(以上都没有，请详细填写)</el-col>
                                        <el-input v-model="scjx" v-if="shelfGoodsRuleForm.used_dosagearr.includes('其他')" placeholder="以上都没有，请详细填写"></el-input>
                                    </el-form-item>
            	                 </el-col>
                                 <el-col :span="16">
        	                        <el-form-item label="是否进口：" prop="is_import">
                                        <el-radio-group v-model="shelfGoodsRuleForm.is_import">
                                            <el-radio  v-for="(item,index) in dictData.is_import" :key="index" :label="item">{{ item }}</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
            	                 </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item label="目前主要合作客户：" prop="partnership">
                                        <el-input v-model="shelfGoodsRuleForm.partnership"  placeholder="请输入目前主要合作客户"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <!--<el-row>-->
                                <!--<el-col :span="16">-->
                                    <!--<el-form-item label="" prop="solutionarr">-->
                                        <!--<span style="color: red;">* </span>解决方案： <span style="color: red;">可多选（最多限选3项）</span>-->
                                        <!--<div v-for="(items,index) in dictData.solution" :key="index">-->
                                            <!--<el-col :span="24">{{ index }}:</el-col>-->
                                            <!--<el-checkbox-group v-model="shelfGoodsRuleForm.solutionarr" @change="handlesolutionChange">-->
                                                <!--<el-checkbox   v-for="(item,idx) in items" :key="idx" :label="item"></el-checkbox>-->
                                            <!--</el-checkbox-group>-->

                                        <!--</div>-->
                                        <!--<el-col :span="24"><el-checkbox v-model="shelfGoodsRuleForm.solutionarr"  @change="handlesolutionChange" label="其他"></el-checkbox>:(以上都没有，请详细填写)</el-col>-->
                                        <!--<el-input v-model="jjfa" v-if="shelfGoodsRuleForm.solutionarr.includes('其他')"  placeholder="以上都没有，请详细填写"></el-input>-->
                                    <!--</el-form-item>-->
                                <!--</el-col>-->
                            <!--</el-row>-->
                            <el-row>
                                <el-col :span="16">
                                    <el-form-item label="" prop="solutionarr">
                                        <span style="color: red;">* </span>解决方案： <span style="color: red;">可多选（最多限选3项）</span>
                                            <el-checkbox-group v-model="shelfGoodsRuleForm.solutionarr" @change="handlesolutionChange">
                                                <el-checkbox v-for="(item,index) in dictData.solution" :key="index" :label="item"></el-checkbox>
                                            </el-checkbox-group>
                                        <el-col :span="24"><el-checkbox v-model="shelfGoodsRuleForm.solutionarr"  @change="handlesolutionChange" label="其他"></el-checkbox>:(以上都没有，请详细填写)</el-col>
                                        <el-input v-model="jjfa" v-if="shelfGoodsRuleForm.solutionarr.includes('其他')"  placeholder="以上都没有，请详细填写"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="16">
                                    <el-form-item label="可提供制造加工的剂型和产品形态：" prop="provide_used_dosagearr">
                                        <el-checkbox-group v-model="shelfGoodsRuleForm.provide_used_dosagearr">
                                            <el-checkbox v-for="(item,index) in dictData.provide_used_dosage" :key="index" :label="item"></el-checkbox>
                                        </el-checkbox-group>
                                        <el-col :span="24"><el-checkbox  v-model="shelfGoodsRuleForm.provide_used_dosagearr" label="其他"></el-checkbox>:(以上都没有，请详细填写)</el-col>
                                        <el-input v-model="cpxt" v-if="shelfGoodsRuleForm.provide_used_dosagearr.includes('其他')" placeholder="以上都没有，请详细填写"></el-input>
                                    </el-form-item>
                                </el-col>

                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item
                                            label="产品或解决方案图片"
                                            prop="solution_images"
                                            class="form-width"
                                    >
                                        <div style="display: flex">
                                            <div class="image-wrap" v-if="shelfGoodsRuleForm.solution_images">
                                                <div
                                                        class="image"
                                                        v-for="(item, index) in shelfGoodsRuleForm.solution_images"
                                                        :key="item.url"
                                                >
                                                    <el-image :src="$imgOssUrl + item.url"></el-image>
                                                    <div class="upload-span">
                                                <span
                                                        class="upload-icon"
                                                        @click.stop="
                                                    handlePictureCardPreview($imgOssUrl + item.url)
                                                "
                                                ><i class="el-icon-zoom-in"></i
                                                ></span>
                                                        <span
                                                                class="upload-icon"
                                                                @click.stop="handleImgRemove(index)"
                                                                style="margin-left: 20px"
                                                        ><i class="el-icon-delete"></i
                                                        ></span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-if="shelfGoodsRuleForm.solution_images.length < 3">
                                                <el-upload
                                                        :action="$Url"
                                                        list-type="picture-card"
                                                        :headers="headers"
                                                        :multiple="false"
                                                        :on-progress="handleProgressImgs"
                                                        :on-success="handleImgsSuccess"
                                                        :on-error="handleImgsError"
                                                        :show-file-list="false"
                                                >
                                                    <i class="el-icon-plus" v-if="!progressImgsVisible"></i>
                                                    <div v-if="progressImgsVisible" style="padding-top: 30px">
                                                        <el-progress
                                                                :percentage="progressImgsPercent"
                                                                type="circle"
                                                                :width="80"
                                                        ></el-progress>
                                                    </div>
                                                </el-upload>

                                            </div>
                                        </div>
                                        <div class="img-tips">
                                            上传图片接受JPG、PNG格式、图片大小不超过2M,分辨率不小于300dpl
                                        </div>

                                    </el-form-item>
                                    <!-- <el-form-item label="产品图片：" prop="imgs">
                                            <el-upload
                                              class="tp_update"
                                              action="/kindeditor/php/uploadApi.php?mode=3"
                                              name='imgFile'
                                              :on-success="handleAvatarPictureSuccess"
                                              list-type="picture-card"
                                              :show-file-list="false"

                                          >
                                              <img v-if="cpImgList[0]" :src="Imghttp + cpImgList[0]" class="avatar">
                                              <div class="upload-tip" v-else>
                                                  <i class="el-icon-plus">
                                                      <p class="el-icon-tip">请上传高清图片</p>
                                                  </i>
                                              </div>
                                          </el-upload>
                                  </el-form-item> -->
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="16">
                                    <el-form-item label="希望开发的客户类型：" prop="hope_customerarr">
                                        <el-checkbox-group v-model="shelfGoodsRuleForm.hope_customerarr">
                                            <el-checkbox  v-for="(item,index) in dictData.hope_customer" :key="index" :label="item" ></el-checkbox>
                                        </el-checkbox-group>
                                        <el-col :span="24"><el-checkbox  v-model="shelfGoodsRuleForm.hope_customerarr" label="其他"></el-checkbox>:(以上都没有，请详细填写)</el-col>
                                        <el-input v-model="khlx" v-if="shelfGoodsRuleForm.hope_customerarr.includes('其他')" placeholder="以上都没有，请详细填写"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="16">
                                    <el-form-item label="是否自有工厂：" prop="is_factory">
                                        <el-radio-group v-model="shelfGoodsRuleForm.is_factory">
                                            <el-radio  v-for="(item,index) in dictData.is_factory" :key="index" :label="item">{{ item }}</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="16">
                                    <el-form-item label="是否有海外工厂：" prop="is_overseas_factory">
                                        <el-radio-group v-model="shelfGoodsRuleForm.is_overseas_factory">
                                            <el-radio  v-for="(item,index) in dictData.is_overseas_factory" :key="index" :label="item">{{ item }}</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>

                                <el-col :span="16">
                                    <el-form-item label="是否自有原料：" prop="is_self_materials">
                                        <el-radio-group v-model="shelfGoodsRuleForm.is_self_materials">
                                            <el-radio  v-for="(item,index) in dictData.is_self_materials" :key="index" :label="item">{{ item }}</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="16">
                                    <el-form-item label="是否能根据客户需求提供解决方案：" prop="provide_solution">
                                        <el-radio-group v-model="shelfGoodsRuleForm.provide_solution">
                                            <el-radio  v-for="(item,index) in dictData.provide_solution" :key="index" :label="item">{{ item }}</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row>
                                <el-col :span="16">
                                    <el-form-item label="是否有30天推出新品的能力：" prop="push_new_product">
                                        <el-radio-group v-model="shelfGoodsRuleForm.push_new_product">
                                            <el-radio  v-for="(item,index) in dictData.push_new_product" :key="index" :label="item">{{ item }}</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                        </template>  
                        <!-- 选品对接会报名 表单 -->
                        <!--<template v-if="templateTpye=='2'">-->


                         <!---->
                        <!--</template> -->
                        <el-row>
                                <el-form-item class="save_btn">
                                    <el-button @click="goback">返 回</el-button>
                                    <el-button type="primary"  @click="submitForm('shelfGoodsRuleForm',1)" :disabled="disableds">保存</el-button>
                                </el-form-item>
                            </el-row>
                    </el-form>
                  </template>
                 <el-dialog :visible.sync="dialogVisible">
                     <img style="max-width:80%;max-height: 500px;margin: 0 auto;" :src="dialogImageUrl" alt="">
                 </el-dialog>
	         </div>
            </div>
       </div>
    </div>
</template>

<script>
import {marketNhneDict,addNhneMarketProduct} from "@/api/api";
import '../../style/base.css'
import top from "../../components/top.vue"; //头部
import navMenu from "../../components/navMenu.vue"; //左侧步骤条
import moment from "moment";

 export default {
    name:'addproductList',
    components: { top, navMenu },
    data(){
        return{
            radio1:'',
            checkList:[],
            templateTpye:'',// 1货架好物模版表单 2 选品对接会报名模版表单  3 极智工场报名模版表单
            uploadUrl:'',
		    dir:'',
		    cpList:[],//
		    cpImgList:[],
		    Imghttp:'https://oss.larspring.com/pharmchina',
		    cp_filelist:[],
		    ruleForm:{
		        goodsName:'',     //产品名称
		        yearSale:'',      //年销售额
		        nhne_ProductClass:'', //产品类别
		        features:'',      //产品特点
		        newfeatures:[],
		        introduction:'',  //产品简介
		        burdenImg:[],     //产品配料表
		        characteristic:'',//工艺特点
		        advantages:'',    //产品卖点
		        imgs:[],          //产品图片
		    },
          
            shelfGoodsRuleForm:{
                changeproductClass:[],
                goodsName:'',//产品图片
                productClass:'',//产品类别
                imgs:"",
                sales_channel:"",
                retail_price:"",
                up_suggest1:'',
                up_suggest:"",
                producible_dosage:"",
                expand_channels:"",
                market_time_new:"",
                market_time:"",
                solutionarr:[],
                solution:"",
                used_dosagearr:[],
                used_dosage:"",
                solution_images:[],
                solution_image:"",
                partnership:"",
                hope_customer:"",
                hope_customerarr:[],
                is_factory:"",
                is_overseas_factory:"",
                is_self_materials:"",
                provide_solution:"",
                push_new_product:"",
                yearSale:"",
                provide_used_dosage:"",
                provide_used_dosagearr:[],
                introduction:"",
                is_import:""
            },
           
		    dialogImageUrl: '',// 预览图片
		    dialogVisible: false, //预览弹框
	        // rules: {
            //    goodsName:[
            //        { required: true, message: '请输入产品名称', trigger: 'blur' },
            //     ],
            //     yearSale: [
            //         { required: true, message: '请输入年销售额', trigger: 'blur' },
            //     ],
            //     nhne_ProductClass: [
            //         { required: true, message: '请输入产品类别', trigger: 'blur' },
            //     ],
            //     newfeatures: [
            //         { required: true, message: '请选择至少一个产品特点', trigger: 'blur' },
            //     ],
            //      introduction: [
            //         { required: true, message: '请输入产品简介', trigger: 'blur' },
            //     ],
            //       characteristic: [
            //         { required: true, message: '请输入工艺特点', trigger: 'blur' },
            //     ],
            //      advantages: [
            //         { required: true, message: '请输入产品卖点', trigger: 'blur' },
            //     ],
            //      burdenImg: [
            //         { required: true, message: '请上传产品配料表', trigger: 'blur' },
            //     ],
            //      imgs: [
            //         { required: true, message: '请上传产品图片', trigger: 'blur' },
            //     ],
            // },
            shelfGoodsRules:{
                goodsName:[
                   { required: true, message: '请输入产品名称', trigger: 'blur' },
                ],
                changeproductClass:[
                   { required: true, message: '请输入产品类别', trigger: 'blur' },
                ],
                market_time_new: [
                    { type: 'date', required: true, message: '请选择上市时间', trigger: 'change' }
                ],
                yearSale:[
                   { required: true, message: '请输入产品年销售额', trigger: 'blur' },
                ],
                retail_price:[
                   { required: true, message: '请输入产品零售价', trigger: 'blur' },
                ],
                sales_channel:[
                   { required: true, message: '请输入目前已有主要销售渠道', trigger: 'blur' },
                ],
                expand_channels:[
                   { required: true, message: '请输入希望开拓销售渠道', trigger: 'blur' },
                ],
                introduction:[
                { required: true, message: '请输入产品简介', trigger: 'blur' },
                ],
                imgs:[
                  { required: true, message: '请上传产品图片', trigger: 'blur' },
                ],
                up_suggest1: [
                    {  required: true, message: '请选择货架选择', trigger: 'change' }
                ],
                used_dosagearr: [
                    { type: 'array', required: true, message: '请选择可生产剂型', trigger: 'change' }
                ],
                is_import:[
                  { required: true, message: '请选择是否进口', trigger: 'change' },
                ],
                partnership:[
                  { required: true, message: '请选择是否进口', trigger: 'blur' },
                ],
                solutionarr:[
                   { type: 'array', required: true, message: '请选择解决方案', trigger: 'change' }
                ],
                provide_used_dosagearr:[
                   { type: 'array', required: true, message: '请选择可提供制造加工的剂型和产品形态', trigger: 'change' }
                ],
                solution_images:[
                   { type: 'array', required: true, message: '请上传产品或解决方案图片', trigger: 'change' }
                ],
                hope_customerarr:[
                   { type: 'array', required: true, message: '请选择希望开发的客户类型', trigger: 'change' }
                ],
                is_factory:[
                { required: true, message: '请选择是否自有工厂', trigger: 'blur' }, 
                ],
                is_overseas_factory:[
                { required: true, message: '请选择是否有海外工厂', trigger: 'blur' }, 
                ],
                is_self_materials:[
                { required: true, message: '请选择是否自有原料', trigger: 'blur' }, 
                ],
                provide_solution:[
                { required: true, message: '请选择是否能根据客户需求提供解决方案', trigger: 'blur' }, 
                ],
                push_new_product:[
                { required: true, message: '请选择是否有30天推出新品的能力', trigger: 'blur' }, 
                ]
                
            },
            
           
            award_id:'',
            tablist:{},
            disableds:false,
            productlist:[],
            dictData:{},//字典数据
            headers:{},
            productClass:[],
            maxselectionSelections:1,
            maxsolutionSelections:3,
            hjxz:'',
            scjx:'',
            jjfa:'',
            cpxt:'',
            khlx:'',
            progressCpVisible: false,
            progressCpPercent: 0,
            progressImgsVisible:false,
            progressImgsPercent:0,
            pickeroptions0:{
                disabledDate(date){
                    if (!date) return false; // 如果日期为空，允许选择
                    const today = new Date();
                    today.setHours(0, 0, 0, 0); // 设置为当天的00:00:00
                    const tomorrow = new Date(today);
                    tomorrow.setDate(today.getDate() + 1); // 计算明天的日期
                    return date.getTime() >= tomorrow.getTime(); // 禁用明天及之后的日期
                }
            },
        }
    },
     created(){
         this.itemdata=JSON.parse(sessionStorage.getItem("itemdata"))
         this.dictData=JSON.parse(sessionStorage.getItem('dictData'))
         this.productClass=JSON.parse(sessionStorage.getItem('productClass'))
     },
    mounted() {
            //    //获取url上的参数
            //    this.award_id = this.getQueryString('id');
            //  this.gettablist()
            //  this.getproductlist()‘ 
            let token = localStorage.getItem("token");
            this.headers = {
              token: token,
            };
            this.templateTpye=this.itemdata.id;
            // this.getmarketNhneDict()
                
        },
    methods: {
        handleProgressImgs(event, file, fileList) {
            console.log(event, "====event");
            // 显示进度条
            this.progressImgsVisible = true;
            // 计算进度百分比
            this.progressImgsPercent = Math.floor((event.loaded / event.total) * 100);
        },
        handleProgressCp(event, file, fileList) {
            console.log(event, "====event");
            // 显示进度条
            this.progressCpVisible = true;
            // 计算进度百分比
            this.progressCpPercent = Math.floor((event.loaded / event.total) * 100);
        },
        // 货架选择 只能选择一项
      //   handleselectionChange(value) {
      //       // 如果选择的项数超过最大限制
      //       if (this.shelfGoodsRuleForm.up_suggestarr.length > this.maxselectionSelections) {
      //           // 取出超出的项
      //           this.$message.error(`最多只能选择 ${this.maxselectionSelections} 项`);
      //
      //           // 使选项回到上一个合法状态
      //           this.shelfGoodsRuleForm.up_suggestarr = this.shelfGoodsRuleForm.up_suggestarr.slice(0, this.maxselectionSelections);
      //       }
      // },
       // 解决方案 只能选择三项
      handlesolutionChange(){
            // 如果选择的项数超过最大限制
            if (this.shelfGoodsRuleForm.solutionarr.length > this.maxsolutionSelections) {
                // 取出超出的项
                this.$message.error(`最多只能选择 ${this.maxsolutionSelections} 项`);
                
                // 使选项回到上一个合法状态
                this.shelfGoodsRuleForm.solutionarr = this.shelfGoodsRuleForm.solutionarr.slice(0, this.maxsolutionSelections);
            }
      },
      handleChange(value) {
        
        this.shelfGoodsRuleForm.productClass=value[1]
        
      },
      goback(){
         this.$router.back()
      },
       // 获取评奖表单字典数据
        // getmarketNhneDict(){
        //     marketNhneDict({}).then(res=>{
        //         console.log(res,"res")
        //         if(res.data.code==1){
        //             let lists=[];
        //            this.dictData=res.data.data;
        //            let productClass=res.data.data.productClass;
        //            if(productClass){
        //               for(let key in productClass){
        //                 lists.push({
        //                     label:key,
        //                     value:key,
        //                     children:productClass[key].map(item=>({label:item,value:item}))
        //                 })
        //                 this.productClass=lists;
        //                 console.log(lists,"lists")
        //               }
                     
        //            }
        //         }
        //     }).catch(err=>{
        //         console.log(err)
        //     })
        // },
            // 产品图片删除
             handleRemove(file, fileList) {
                    this.shelfGoodsRuleForm.imgs = "";
            },
            handleLogoSuccess(resData, file, fileList) {
                if(resData.code == 0){
                    this.$message.error(resData.msg);
                    return false;
                }
                this.shelfGoodsRuleForm.imgs = resData.data.url;
                this.progressCpVisible = false;
                },
            // 产品图片上传失败
            handleLogoError(err, file, fileList) {
                this.$message.error(err.message);
                this.progressCpVisible = false;
                },
          //产品或解决方案图片上传成功
            handleImgsSuccess(resData, file, fileList) {
                if(resData.code == 0){
                    this.$message.error(resData.msg);
                    return false;
                }
            this.shelfGoodsRuleForm.solution_images.push({ url: resData.data.url });
                this.progressImgsVisible=false
            },
            // 产品或解决方案图片上传失败
            handleImgsError(err, file, fileList) {
            this.$message.error(err.message);
                this.progressImgsVisible=false
            },
            //产品或解决方案图片删除
            handleImgRemove(index) {
                this.shelfGoodsRuleForm.solution_images.splice(index, 1);
                },
            //预览图片
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file;
                this.dialogVisible = true;
             },
            //  仅保存 && 添加产品
            submitForm(formName,type){
                        this.$refs[formName].validate((valid) => {
                            if (valid) {
                                this.disableds = true
                                    setTimeout(()=>{
                                        this.disableds = false;
                                    },2000)

                                    let data= this.shelfGoodsRuleForm
                                    let Url=[]

                                        data.up_suggest=this.shelfGoodsRuleForm.up_suggest1;
                                        console.log(data.up_suggest,"data.up_suggest")
                                        if(data.up_suggest=='其他'){
                                            // data.up_suggestarr = data.up_suggestarr.filter(item => item !== '其他');
                                            data.up_suggest='#'+this.hjxz
                                        }
                                        if(data.used_dosagearr.includes('其他')){
                                            data.used_dosagearr = data.used_dosagearr.filter(item => item !== '其他');
                                            data.used_dosagearr.push('#'+this.scjx)
                                        }
                                        console.log(data.used_dosagearr,"data.used_dosagearr")
                                        data.used_dosage=data.used_dosagearr+'';

                                        let date=moment(new Date(data.market_time_new).getTime()).format("YYYY-MM-DD")
                                        data.market_time=date;

                                    if(this.itemdata.id==3){ //是OEM
                                        data.productClass='OEM'
                                        if(data.solutionarr.includes('其他')){
                                            data.solutionarr = data.solutionarr.filter(item => item !== '其他');
                                            data.solutionarr.push('#'+this.jjfa)
                                        }
                                        if(data.hope_customerarr.includes('其他')){
                                            data.hope_customerarr = data.hope_customerarr.filter(item => item !== '其他');
                                            data.hope_customerarr.push('#'+this.khlx)
                                        }
                                        if(data.provide_used_dosagearr.includes('其他')){
                                            data.provide_used_dosagearr = data.provide_used_dosagearr.filter(item => item !== '其他');
                                            data.provide_used_dosagearr.push('#'+this.cpxt)
                                        }
                                        data.solution=data.solutionarr+'';
                                        data.hope_customer= data.hope_customerarr+'';
                                        data.provide_used_dosage= data.provide_used_dosagearr+'';
                                        data.solution_images.map(item=>{
                                            Url.push(item.url)
                                        })
                                        data.solution_image= Url+'';

                                        
                                    }
                                   
                                    
                                    addNhneMarketProduct(this.$qs.stringify(data)).then(res=>{
                                        if(res.data.code==1){
                                            this.$message.success(res.data.msg)
                                            this.$router.back()
                                        }else{
                                            this.$message.waining(res.data.msg)
                                        }

                                    }).catch(err=>{
                                        console.log(err)
                                    })

                         
                            } else {
                                console.log('error submit!!');
                                return false;
                            }
                        });
                    },




        // 基本表单逻辑 24.8.17
		   //产品图片上传
           handleAvatarPictureSuccess(res, file, fileList) {
           
           let fileUrl=[];
           let newfileUrl=[];
           
           // 处理上传成功的响应数据
           if (res.errno == 0) {
                      
               fileUrl.push({
                   url:res.url
               })
               
               newfileUrl.push(res.url);
             // 在这里可以使用获取到的文件 URL 进行后续操作
             this.ruleForm.imgs=fileUrl;
             this.cpImgList=newfileUrl;
            
           } else {
             // 处理上传失败的情况
             console.error('上传失败');
           }
         },  
                   
                   
             // 判断是否pdf
           isPDF(url) {
             if(!url){
               return false
             }
             const fileType = ['pdf']
             const index = url.lastIndexOf('.')
             const type = url.substr(index + 1)
             return fileType.indexOf(type) > -1
           },       
                          //预览图片
           handlePreview(file, fileList) {
              
               if(this.isPDF(file.url)){
                   window.open(file.url, "_blank");
               } else {
                   console.log(file.url)
                   this.dialogImageUrl = file.url;
                   this.dialogVisible = true;
               }
           },
                   
            //         //产品配料表删除
            //  handleRemove(file, fileList) {
            //       this.$confirm(`确认删除文件?`, '提示', {
            //            confirmButtonText: '确定',
            //            cancelButtonText: '取消',
            //            type: 'warning'
            //        }).then(async () => {
            //            let list=[]
            //            this.ruleForm.burdenImg = this.ruleForm.burdenImg.filter((v) => v.url !== file.url)
            //            this.ruleForm.burdenImg.map(item=>{
            //                   list.push(item.url)
            //            })
            //            this.cpList=list
                       
            //        }).catch(()=>{})
            //  },
           //   zhang 4.9  //产品配料表上传
             beforeUpload(file){
                     // 检查文件类型
                     if(file.type == 'image/jpeg' || file.type == 'application/pdf'){
                         
                          this.dir=file.type == 'image/jpeg'?'image':'file';
                          let formData = new FormData();
                          formData.append("imgFile", file);
                          
                          axios.post('kindeditor/php/uploadApi.php?mode=3&dir='+this.dir,formData).then(res => {
                              console.log(res,"res")
                                if (res.data.errno == 0) {
                                       let data = {
                                           url: res.data.url,
                                           uid: file.uid,
                                       }
                                       this.ruleForm.burdenImg = [...this.ruleForm.burdenImg, data];
                                       this.cpList.push(data.url)
                                       console.log(this.ruleForm.burdenImg,"this.ruleForm.burdenImg")
                                       this.$forceUpdate();
                                   }
                                                   
                           }).catch(function (err) { 
                               console.log(err);
                           });  

                          
                          return true
                          
                     }else{
                         this.$message.error('只能上传 JPEG JPG PNG PDF 格式的图片！');  
                          return false
                     }
           
            },
           
           getproductlist(){
               axios.get('api.php?m=nhneProduct.getProductClass&v=3.0',{}).then(res => {
                       //console.log(res, '---获取奖项列表');
                       if(res.status == 200){
                           let data = res.data.rst;
                           this.productlist = data;
                       }
                   }).catch(function (err) { 
                       console.log(err);
                   });  
           },
           gettablist(){
               axios.get('api.php?m=nhneProduct.getProductOption&v=3.0',{}).then(res => {
                       //console.log(res, '---获取奖项列表');
                       if(res.status == 200){
                           let data = res.data.rst;
                           this.tablist = data;
                       }
                   }).catch(function (err) { 
                       console.log(err);
                   });  
              
           },
        //    //  仅保存 && 保存并提交
        //    submitForm(formName,type){
        //        this.$refs[formName].validate((valid) => {
        //            if (valid) {
        //                this.disableds = true
        //                  setTimeout(()=>{
        //                      this.disableds = false;
        //                  },2000)
                         
        //                  let data=Object.assign({},this.ruleForm)
                         
        //                if(this.ruleForm.imgs.length>0){
        //                    data.imgs=JSON.stringify(this.cpImgList)
        //                }
                       
        //                if(this.ruleForm.burdenImg.length>0){
        //                    data.burdenImg=JSON.stringify(this.cpList)
        //                }
                       
        //               if(this.ruleForm.newfeatures.length>0){
        //                    data.features=this.ruleForm.newfeatures+''
        //                }
                       
                        
                           
        //            axios.post('api.php?m=nhneProduct.saveProductData&v=3.0',qs.stringify(data)).then(res => {
        //                //console.log(res, '---获取详情');
        //                if(res.status == 200){
        //                    this.$message.success("保存成功!")
        //                    window.location.href=`<?= URL('discussion.productawardList','id='); ?>${this.award_id}`
        //                }
                       
        //            })
        //            .catch(function (err) { 
        //                console.log(err);
        //            });
                               
                       
        //            } else {
        //                console.log('error submit!!');
        //                return false;
        //            }
        //        });
        //    },

           getQueryString(name) {
               var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
               var r = window.location.search.substr(1).match(reg);
               if (r != null) return unescape(r[2]);
               return null;
           },
           getQueryVariable(variable) {
               var query = window.location.search.substring(1);
               var vars = query.split("&");
               for (var i = 0; i < vars.length; i++) {
                   var pair = vars[i].split("=");
                   if (pair[0] == variable) { return pair[1]; }
               }
               return (false); 
           }
		}
 }
</script>

<style lang="scss" scoped>
    .img-tips {
        color: red;
    }
        .image {
  width: 148px;
  height: 148px;
  border-radius: 6px;
  position: relative;
  display: inline-block;
  /deep/ .el-image {
    width: 148px;
    height: 148px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    .el-image__inner {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }
  .upload-span {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: #000, $alpha: 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all 0.1s;
    border-radius: 6px;
    .upload-icon {
      color: #fff;
      font-size: 22px;
    }
  }
  &:hover {
    .upload-span {
      opacity: 1;
    }
  }
}
body{
    background: #fff !important;
}
.content{
    background: #fff;
    margin-right: 40px ;
}
/*评奖报名首页*/
.main{
    padding: 30px 0px 30px 40px;
    box-sizing: border-box;
}
.main .title{
    color: #000;
    font-size: 20px;
    font-weight: 500;
    line-height: 30px;
    font-family: SourceHanSansCN, SourceHanSansCN;
}
.main .dis-notice{
    color: #000;
    padding: 20px;
    box-sizing: border-box;
    font-size: 14px;
    line-height: 22px;
    border-radius: 8px;
    background: #F8F8F8;
    margin: 20px 0 52px;
    font-family: PingFangSC, PingFang SC;
}
.main .dis-notice p{
    max-width: 730px;
}
.main .dis-notice .seek{
    font-size: 16px;
    line-height: 24px;
    padding-top: 15px;
}
.main .dis-list .dis-item{
    width: 44%;
    height: 162px;
    max-width: 510px;
    min-width: 430px;
    margin-right: 30px;
    margin-bottom: 30px;
    background: #F6F7FC;
    border-radius: 8px;
    box-sizing: border-box;
    padding: 31px 20px 20px;
    font-size: 14px;
    color: #000;
    line-height: 20px;
    position: relative;
    font-family: PingFangSC, PingFang SC;
}
.main .dis-list .dis-item-left .dis-title{
    font-size: 24px;
    font-weight: 500;
    line-height: 33px;
}
.main .dis-list .dis-item-left .dis-time{
    font-size: 20px;
    padding: 15px 0;
    line-height: 28px;
}
.main .dis-list .dis-item-left .dis-more a{
    color: #999;
    display: flex;
    align-items: center;
}
.main .dis-list .dis-item-left .dis-more .more-img{
    width: 17px;
}
.main .dis-list .dis-item .sign-tips{
    width: 116px;
    height: 39px;
    color: #FF0000;
    font-size: 18px;
    text-align: center;
    line-height: 39px;
    position: absolute;
    top: 0;
    right: 0;
    background: linear-gradient( 180deg, rgba(255,0,0,0) 0%, rgba(255,0,0,0.2) 100%);
    border-radius: 8px 8px 8px 26px;
}
.main .dis-list .dis-item-right .dis-btn{
    width: 128px;
    height: 44px;
    color: #FFF;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    line-height: 44px;
    text-align: center;
    background: #FC9749;
    border-radius: 8px;
    border: 1px solid #FC9749;
    font-family: PingFangSC, PingFang SC;
}
.main .dis-list .dis-item-right .dis-ebtn{
    color: #FC9749;
    background: #FFF;
    border: 1px solid #FC9749;
}


/*奖项详情*/
.main-details .details-top{
    height: 78px;
    padding: 0 40px;
    font-size: 18px;
    font-family: SourceHanSansCN, SourceHanSansCN;
    color: #000;
    background: #F3F4F8;
}
.main-details .details-top .close-btn{
    width: 130px;
    height: 44px;
    color: #666;
    font-size: 14px;
    line-height: 44px;
    text-align: center;
    background: #FFF;
    border-radius: 8px;
    cursor: pointer;
}
.main-details .details-title{
    color: #3D83E8;
    font-size: 16px;
    padding-top: 20px;
    line-height: 24px;
    margin-left: 40px;
    padding-bottom: 10px;
    font-family: PingFangSC, PingFang SC;
    border-bottom: 1px solid #3D83E9;
}
.main-details .details-content{
    padding: 20px;
    margin: 20px 40px;
    background: #F8F8F8;
    border-radius: 8px;
}

/*品牌企业奖——信息填写*/
.content_main .content-notice{
    padding: 20px;
    font-size: 14px;
    color: #000;
    line-height: 22px;
    min-height: 106px;
    background: #F8F8F8;
    border-radius: 8px;
    margin-right: 38px;
    margin-bottom: 20px;
    box-sizing: border-box;
    font-family: PingFangSC, PingFang SC;
}
.save_btn .el-button {
    width: 130px;
}

.awards-upload .el-upload--picture-card,
.awards-upload .el-upload--picture-card .upload-tip,
.awards-upload .el-upload-list--picture-card .el-upload-list__item{
    width: 262px;
    height: 128px;
}
.awards-upload .el-upload--picture-card{
    background: #fff;
}
.awards-upload .el-upload--picture-card .upload-tip i{
    padding-top: 20px;
    display: inline-block;
}
.awards-upload .el-upload--picture-card .upload-tip .upload-img{
    width: 34px;
    height: 34px;
    display: block;
    margin: 0 auto 15px;
}
.awards-upload .el-upload--picture-card .upload-tip .tips{
    width: 100%;
    height: 24px;
    color: #000;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
}
.awards-upload .el-upload-list--picture-card .el-upload-list__item{
    position: relative;
}
.awards-upload .el-upload-list--picture-card .el-upload-list__item-thumbnail{
    height: auto;
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.pdf_box{
    width: 358px;
    height: 68px;
    background: #FFFFFF;
    border-radius: 8px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    padding: 0 15px;
    box-sizing: border-box;
}
.pdf_box img{
    width: 28px;
    height: 28px;
}
.txt_box{
    margin: 0 58px 0 10px;
}
.txt_title{
    width: 173px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 13px;
    color: #000000;
    line-height: 24px;
}
.txt_size{
    width: 39px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 24px;
}
.xz_btn{
    width: 54px;
    height: 26px;
    line-height: 26px;
    background: #E4EFFF;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #3D83E9;
    text-align: center;
    cursor: pointer;
}

.header_title{
    font-size: 18px;
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 400;
    color: #000000;
}
.header_main{
    background: #F3F4F8;
    padding: 30px 38px;
    box-sizing: border-box;
   
}
.header_step_box{
    display: flex;
    margin-top: 40px;
}
.step_item{
    display: flex;

    margin-right: 126px;
}
.step_number{
    width: 32px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #BBBBBB;
    border-radius: 21px;
    font-size: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
}
.step_txt{
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    margin-left: 10px;
}
.step_txt .txt1{
    color: #000000;
    margin-bottom: 5px;
}
.step_txt .txt2{
    color: #999999;
}

.content_main{
    padding: 30px 0 ;
    box-sizing: border-box;
}
.content_main_title{
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #3D83E8;
    padding-bottom: 10px;
    border-bottom: 1px solid #3D83E9;
    margin-bottom: 30px;
}
.save_btn{
    display: flex;
    justify-content: center;
    margin-top: 162px;
}
.step_actitive{
    background: #1677FF !important;
}
.txt_actitive{
    color: #000000 !important;
}
/*图片*/
.tp_update  .el-upload-dragger{
         width: 148px !important;
         height: 148px !important;
    }
.tp_update  .el-upload--picture-card{
   width: 148px !important;
   height: 148px !important;
   /*border: none !important;*/
}
.tp_update .el-icon-tip{
    display: block !important;
    font-size: 16px !important;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: rgba(153,153,153,0.88);
     margin-top: 15px;
}
.tp_update .el-upload--picture-card i{
    display: flex;
    flex-direction: column;
    width: 148px !important;
    height: 148px;
    align-items: center;
    justify-content: center;
    font-size: 36px;
   
}

/*pdf 和 图片*/
.pdf_update .el-upload-dragger{
     width: 262px !important;
     height: 128px !important;
}
    
.pdf_update .el-upload--picture-card{
  width: 262px !important;
     height: 128px !important;
   border: none !important;
}

.pdf_update .el-upload--picture-card i{
    display: flex;
    flex-direction: column;
    width: 262px !important;
    align-items: center;
    justify-content: center;
    font-size: 16px;
      font-size: 16px !important;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: rgba(0,0,0,0.88);
     margin-top: 8px;
}
.pdf_update .el-upload--picture-card{
    line-height: 3;
}
.discussion_upload{
    width: 34px;
    height: 32px;
    margin-top: 22px;
}
.zh_tips1{
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #FF4D4F;
    margin-bottom: 16px;
}
.zh_tips_checkbox span{
    font-size: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #FF4D4F;
}

.discussion_susscess{
    width: 77px;
    height: 77px;
    margin-right: 20px;
}
.susscess_icon_box{
    display:flex;
    flex-direction: column;
    justify-content:center;
    align-items: center;
}
.susscess_icon_box span{
    font-size: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #000000;
    margin-top: 18px;
}
.susscess_tips{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 960px;
    height: 88px;
    background: rgba(255,77,79,0.08);
    border-radius: 8px;
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #FF4D4F;
    margin: 20px 0;
}
.adress_box{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #222222;
}
.adress_input{
    width: 660px;
    /*height: 48px;*/
    background: #EDF1F7;
    border-radius: 5px;
}
.fz_btn{
    width: 95px;
    height: 38px;
    line-height: 38px;
    background: #FFFFFF;
    border-radius: 3px;
    border: 1px solid #3D83E9;
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #3C81E6;
    text-align: center;
    margin-left: 30px;
}
a{
    color: #FFFFFF;
}
.demo-ruleForm .el-form-item {
    padding-right: 30px;
}


.awards-upload .el-upload--picture-card,
.awards-upload .el-upload--picture-card .upload-tip,
.awards-upload .el-upload-list--picture-card .el-upload-list__item{
    width: 262px;
    height: 128px;
}
.awards-upload .el-upload--picture-card{
    background: #fff;
}
.awards-upload .el-upload--picture-card .upload-tip i{
    padding-top: 30px;
    display: inline-block;
}
.awards-upload .el-upload--picture-card .upload-tip .upload-img{
    width: 34px;
    height: 34px;
    display: block;
    margin: 0 auto 15px;
}
.awards-upload .el-upload--picture-card .upload-tip .tips{
    width: 100%;
    height: 24px;
    color: #000;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
}
.awards-upload .el-upload-list--picture-card .el-upload-list__item{
    position: relative;
}
.awards-upload .el-upload-list--picture-card .el-upload-list__item-thumbnail{
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.edit-icon{
    width: 35px;
    position: absolute;
    right: 30px;
    z-index: 99;
    cursor: pointer;
}


</style>
<style>
   /* .el-upload .avatar{
        position: absolute;
        top: 50%;
        left: 50%;
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        transform: translate(-50%, -50%);
    }
      .el-upload,
 .el-upload-list .el-upload-list__item{
        width: 262px;
        height: 128px;
        background: #FFF;
        border-radius: 8px;
        position: relative;
        border: 1px dashed #E0E0E0;
    } */

   @media only screen and (max-width: 767px) {
       .el-col-12{
           width: 100%;
       }
       .el-col-8{
           width: 100%;
       }
       .content .el-button {
           transform: translateX(0);
           min-width: 120px;
       }
   }

</style>

<style >
.el-radio-group{
    font-size: 12px !important;
    line-height: 3 !important;
}
.el-form--label-top .el-form-item__label{
    font-weight: bolder !important;
}

</style>